module.exports = __webpack_public_path__ + "static/media/maolanshanadj.698f6fd3.webp";